<template>
    <div class="visualRecognition">
  <!-- <div class="row mx-0 mb-4">
      <div class="col-lg-5 col-4"></div>
      <div class="col-lg-3 col-4"> -->
        <!-- <input type="search" name="searchVisual" id class="search-input" />
        <i class="fa fa-search search-icon" aria-hidden="true"></i> -->
      <!-- </div>
      <div class="col-lg-2 col-1"></div> -->
      <a href="/app/secure/visualrecognition/create"  class="btn create-btn ">New Inspection</a>
    <!-- </div> -->
    <table  class="table visualRecognition-table">
        <thead>
          <tr>
            <th>Commodity</th>
            <th>Inspection Date</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in items" :key="item.id">
            <td>{{item.commodity}}</td>
            <td>{{formatDate(item.inspection_date)}}</td>
            <td>
                <a class = "btn view" :href="`/app/secure/visualrecognition/view/${item.commodity}/${item.id}`" style = "width:20px;" ></a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
</template>

<script>
import '../VisualRecognition.scss'
export default {
    data() {
    return {};
  },
  computed: {
    items(){
      return this.$store.state.VisualAnalysis.reports.reverse()
    }
  },
  methods: {
    formatDate(dt) {
      if (!dt || dt == "") return "N/A";
      var date = new Date(dt);
      var x = date.toDateString().substring(4);
      return x.slice(0, 3) + "," + x.slice(3);
    },
    viewAnalysis(id){
      alert(id)
    }
    
  },

  mounted() {
    this.$store.dispatch("getAllVisualAnalysisReports")
  },
  created() {
    this.$store.commit("changePathLabel", {
      view: "Autonomous Inspection",
      categories: [
          { name: "Powered By AI", focus: false }

      ]
    });
  }
}
</script>